<button type="button" [disabled]="disabled" class="btn color-circle shrink-0" [matMenuTriggerFor]="colorMenu" [style.backgroundColor]="selectedId">
  <craft-icon class="svg-icon text-size-11" name="arrows--arrow-head-down-sm"></craft-icon>
</button>
<mat-menu #colorMenu="matMenu" class="color-menu">
  <ng-template matMenuContent="">
    <button
      *ngFor="let color of items | keyvalue; trackBy: identify"
      mat-menu-item=""
      class="btn"
      [ngClass]="{ selected: selectedId === color.key }"
      [style.backgroundColor]="color.value"
      (click)="selectItem(color.value)"
      type="button"
    ></button>
  </ng-template>
</mat-menu>
